import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Footer.css"; // Archivo CSS para estilos personalizados

function Footer() {
  return (
    <footer className="footer mt-auto py-3 bg-light">
      <div className="container">
        <div className="row">
          {/* Columna 1: Enlaces rápidos */}
          <div className="col-md-4 mb-3">
            <h5>Enlaces Rápidos</h5>
            <ul className="list-unstyled">
              <li>
                <a href="http://ia.suriyaco.ar" className="text-decoration-none text-dark">
                  Inicio
                </a>
              </li>
              <li>
                <a href="https://suriyaco.ar" className="text-decoration-none text-dark">
                  Acerca de
                </a>
              </li>
              <li>
                <a href="https://suriyaco.ar/contact" className="text-decoration-none text-dark">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 2: Redes sociales */}
          <div className="col-md-4 mb-3">
            <h5>Redes Sociales</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://twitter.com/tu_usuario"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <i className="bi bi-twitter me-2"></i>Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/tu_usuario"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <i className="bi bi-instagram me-2"></i>Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/suriyaco82/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <i className="bi bi-github me-2"></i>GitHub
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 3: Información de contacto */}
          <div className="col-md-4 mb-3">
            <h5>Contacto</h5>
            <ul className="list-unstyled">
              <li>
                <i className="bi bi-envelope me-2"></i>
                <a
                  href="mailto:at@isuriyaco.ar"
                  className="text-decoration-none text-dark"
                >
                  at@suriyaco.ar
                </a>
              </li>
              <li>
                <i className="bi bi-geo-alt me-2"></i>
                <span>La Rioja, Argentina</span>
              </li>
              <li>
                <i className="bi bi-phone me-2"></i>
                <span>+54 380 4 - 375678</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Derechos de autor */}
        <div className="text-center mt-4">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} IA Suriyaco Valley. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;